<template>
    <div v-observe-visibility="visibilityChanged">


        <v-dialog class="loading-dialog"
                  v-model="creatingOrderConfirmation"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">Creating Order Confirmation...</v-card-title>
                    </v-flex>
                    <v-flex justify-end>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Position</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this position?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deletePosition()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-layout id="table-container" row>
            <v-flex xs12 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Order Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loading"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openConfirmOrderPositionDialog(props.item.id)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{
                                    props.item.customers_offers_position.customers_offer.offer_number }}
                                </td>
                                <td class="text-xs-left">{{ props.item.product.reference }}</td>
                                <td class="text-xs-left">{{ props.item.product.manufacturer.name }}</td>
                                <td class="text-xs-left">{{ props.item.quantity }}</td>
                                <td class="text-xs-left">{{props.item.unit.code }}</td>
                                <td class="text-xs-right">{{props.item.unit_sales_price}}
                                    {{props.item.customers_offers_position.customers_offer.currency.name}}
                                </td>
                                <td class="text-xs-right">{{props.item.total_sales_price}}
                                    {{props.item.customers_offers_position.customers_offer.currency.name}}
                                </td>
                                <td class="text-xs-left">{{props.item.vat.name }}</td>
                                <td class="text-xs-left">{{ props.item.purchase_orders_positions_status.name }}</td>

                                <td class="text-xs-right">

                                    <v-icon color="red"
                                            class="ma-1"
                                            @click="deletePositionDialog(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-end mr-5>
            <v-flex xs12 sm12 md1 pr-4 pt-4 mr-5>
                <v-btn :loading="getCreatingPurchaseOrderMessage" class="secondary white--text"
                       @click.native="createCustomerOrderConfirmation()">
                    Create Order Confirmation
                </v-btn>
            </v-flex>
        </v-layout>
        <!--Confirm Dialog-->
        <confirmOrderPosition/>

    </div>
</template>

<script>
    import {
        Settings,
        PurchaseOrder,
        PurchaseOrderPosition
    } from '../../../store/namespace-helper'

    import confirmOrderPosition from './ConfirmOrderPositionDialog.vue'

    import _ from 'lodash'

    export default {
      name: 'order-positions',
      components: {confirmOrderPosition},
      data () {
        return {
          isVisible: false,
          hide: true,
          activeTab: 0,
          headers: [
                    {text: 'Position-ID', value: 'id'},
                    {text: 'Customer Offer Number', value: 'offer_number'},
                    {text: 'Reference', value: 'reference'},
                    {text: 'Manufacturer', value: 'manufacturers_id'},
                    {text: 'Quantity', value: 'quantity'},
                    {text: 'Unit', value: 'unit_id', sortable: false},
                    {text: 'Unit Price', value: 'unit_sales_price', align: 'right'},
                    {text: 'Total Price', value: 'total_sales_price', align: 'right'},
                    {text: 'Tax/Vat', value: 'vats_id', sortable: false},
                    {text: 'Status', value: 'inquiries_position_status_id'},
                    {text: 'Action', value: 'action', sortable: false}
          ],
          pagination: {},
          search: '',
          total: 0,
          rowsPageItems: [{'text': 'All', 'value': -1}],
          creatingOrderConfirmation: false,
          positionData: null,
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false
        }
      },
      mounted () {

      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab order positions visible, load data')
              this.loadItems()
            } else {

            }
          }
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            id: this.selectedItem.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          if (this.selectedItem.id !== 0) {
            this.$store.dispatch(PurchaseOrderPosition.actions.loadPurchaseOrderPositions, query)
          }
        },
        createCustomerOrderConfirmation () {
          this.$store.dispatch(PurchaseOrder.actions.createPurchaseOrderMessage, this.selectedItem.id).then(response => {
            this.creatingOrderConfirmation = true
            this.$echo.private('purchase-order-confirmation-created-chan.' + this.selectedItem.id).listen('PurchaseOrderConfirmationCreated', (payload) => {
              console.log('message sent event: ' + JSON.stringify(payload))
              this.$store.dispatch(PurchaseOrder.actions.reloadSelectedPurchaseOrder, this.selectedItem.id).then(response => {
                this.$echo.leave('purchase-order-confirmation-created-chan.' + this.selectedItem.id)
              })
              this.creatingOrderConfirmation = false
            })
          })
        },
        openConfirmOrderPositionDialog (val) {
          let item = this.getItems.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            console.log('selectedOrderPosition: ' + JSON.stringify(item))
            this.$store.dispatch(PurchaseOrderPosition.actions.setSelectedPurchaseOrderPosition, item)
          }
          this.$store.dispatch(PurchaseOrderPosition.actions.openCloseDialog)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        throttledTranslate: _.debounce(function (q, target) {
          this.translate(q, target)
        }, 450),
        deletePositionDialog (item) {
          this.positionData = _.cloneDeep(item)
          this.deleteDialog = true
        },
        deletePosition () {
          if (!this.$refs.form.validate()) {
            return
          }
          this.deleteDialog = false
          this.deleteChecked = false
          this.$store.dispatch(PurchaseOrderPosition.actions.deleteOrderPositions, this.positionData).then(response => {
            if (response !== null) {
              this.loadItems()
            }
          })
        },
        cancelDeleteDialog () {
          this.deleteDialog = false
          this.$refs.form.reset()
        }

      },
      computed: {
        getItems () {
          this.total = this.$store.getters[PurchaseOrderPosition.getters.purchaseOrderPositions].length
          return this.$store.getters[PurchaseOrderPosition.getters.purchaseOrderPositions]
        },
        selectedItem () {
          return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getCreatingPurchaseOrderMessage () {
          return this.$store.getters[PurchaseOrder.getters.getCreatingPurchaseOrderMessage]
        },
        confirmOrderPositionDialogState () {
          return this.$store.getters[PurchaseOrderPosition.getters.getOpenDialogState]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        confirmOrderPositionDialogState: {
          handler (val) {
            if (!val) {
              this.loadItems()
            }
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }


</style>



// WEBPACK FOOTER //
// src/components/PurchaseOrders/OrderPositions/OrderPositions.vue